import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import { CARD_BOX_SHADOW, CARD_BORDER_RADIUS } from '../../config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCard = styled.div.withConfig({
  displayName: "CardComp__StyledCard",
  componentId: "sc-140jzym-0"
})(["background-color:", ";border-radius:", "px;box-shadow:", ";margin-top:", ";padding:", ";"], ({
  theme
}) => theme.color['fill-surface-default'], CARD_BORDER_RADIUS, CARD_BOX_SHADOW, ({
  theme
}) => theme.space[800], ({
  theme
}) => theme.space[600]);
const CardComp = ({
  children,
  testId
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledCard, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexWrap: "wrap",
        "data-test-id": testId,
        children: children
      })
    })
  );
};
export default CardComp;